import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield\n  (assign\n    this.publicAPI (hash button=(component \"ic-button\" _buttonListIsProcessing=this.processing))\n  )\n}}")